<template>
  <div class="container my-4">
    <router-link :to="{ name: 'ConfigurationsView', query: { deviceName: encodeURI(this.deviceName) } }">
      <fa-icon :icon="['fas', 'chevron-left']" class="mr-2" />{{deviceName}} Konfigurationen
    </router-link>
    <div class="border-bottom mt-3 mb-4">
      <h4 class="mt-3 mb-4">{{deviceName}} Reihenfolge ändern</h4>
    </div>
    <div v-if="isLoading === false">
      <p>Die Reihenfolge kann durch Ziehen und Ablegen verändert werden.</p>
      <div class="card shadow-sm mb-4">
        <table class="table table-striped table-borderless mb-0">
          <draggable tag="tbody" v-model="konfigurationen">
            <tr v-for="element in konfigurationen" :key="`element-${element.id}`">
              <td>{{element.data.name}}</td>
            </tr>
          </draggable>
        </table>
      </div>
      <form v-on:submit.prevent="saveOrder"><SaveButtonComponent :saveButtonState="saveButtonState" /></form>
    </div>
    <SpinnerComponent v-else />
  </div>
</template>

<script>
import SpinnerComponent  from '../components/SpinnerComponent'
import SaveButtonComponent from '../components/SaveButtonComponent'
import draggable from 'vuedraggable'

import { firestore } from '../plugins/firebase'
import { updateDoc, doc, getDocs, collection, orderBy, query } from "firebase/firestore"

export default {
  name: 'ChangeConfigurationOrderView',
  components: {
    SpinnerComponent,
    SaveButtonComponent,
    draggable
  },
  computed: {
    deviceName: function() {
      return decodeURI(this.$route.query.deviceName)
    },
    deviceId: function() {
      return decodeURI(this.$route.params.deviceId)
    }
  },
  data() {
    return {
      isLoading: true,
      konfigurationen: [],
      saveButtonState: ''
    }
  },
  mounted() {
    this.ladeKonfigurationen()
  },
  methods: {
    saveOrder: function() {
      this.saveButtonState = 'saving'

      let promises = []

      this.konfigurationen.forEach((konfiguration, index) => {
        konfiguration.data.orderIndex = index

        promises.push(updateDoc(doc(firestore, 'konfigurationen', konfiguration.id), konfiguration.data))

      })

      Promise.all(promises)
      .then(() => {
        this.saveButtonState = 'done'
        setTimeout(() => {
          this.saveButtonState = ''
        }, 3500)
      })
      .catch(error => {
        console.error(error)
        this.saveButtonState = 'error'
        setTimeout(() => {
          this.saveButtonState = ''
        }, 3500)
      }) // eslint-disable-line no-console
    },
    ladeKonfigurationen: async function() {
      this.konfigurationen = []

      const q = query(collection(firestore, 'konfigurationen'), orderBy("orderIndex", "asc") )

      await getDocs(q)
      .then(docs=>{
        this.isLoading = false
        docs.forEach(document => {
          if (document.data().deviceId === this.deviceId) {
            const element = {
              id: document.id,
              data: document.data()
            }
            this.konfigurationen.push(element)
          }
        })
      })
      .catch(err=>console.error(err))
    }
  }
}
</script>

<style>
table tr td:hover {
  cursor: grab;
}
table tr.sortable-chosen td:hover {
  cursor: grabbing !important;
}
</style>